import { AutogenLayoutlayout_dimuident2 } from "./autogen/AutogenLayoutlayout_dimuident2";
import {  DataDisplayEvent } from "@mcleod/components";

export class layout_dimuident2 extends AutogenLayoutlayout_dimuident2 {

/** This is an event handler for the onDataDisplay event of textboxDimuiIdent. */
  textboxDimuiIdentOnDataDisplay(event: DataDisplayEvent) {
    const txtboxIdent = this.textboxDimuiIdent.text;
    if( txtboxIdent == null || txtboxIdent.length <= 0 )
        this.textboxDimuiIdent.enabled = true;
    else
        this.textboxDimuiIdent.enabled = false;

  }
}
